<style lang="scss" scoped>
.name-mobile-input {
  width: 300px;
  .el-input {
    width: 110px;
  }
}
.export_label {
  width: 100px;
  margin-top: 20px;
  display: inline-block;
}
</style>
<template>
  <!-- 业绩统计 -->
  <div>
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick"
    >
      <el-tab-pane
        label="全部"
        name="0"
      />
      <el-tab-pane
        label="员工"
        name="1"
      />
      <el-tab-pane
        label="编外"
        name="2"
      />

      <SpFinder
        id="1"
        ref="finder"
        class="customerNumber"
        title="客户UV报表"
        :no-selection="true"
        :url="{
          data: finderConfig.requestUrl + '?employee_status=' + activeName
        }"
        :show-tool-bar="false"
        :setting="finderConfig.setting"
        :hooks="{
          beforeSearch: beforeSearch
        }"
        :search="finderConfig.search"
        :columns="finderConfig.columns"
        :actions="finderConfig.actions"
        @reset="onFinderReset"
      >
        <template slot="month">
          <el-date-picker
            v-model="params.month"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月份"
            :picker-options="pickerOptions"
          />
        </template>
        <template slot="guide">
          <span class="m-r-6">门店</span>
          <el-input
            v-model="storeNum"
            placeholder="全部门店"
            class="input-m m-r-6"
            :disabled="true"
            style="width: 240px"
          >
            <div slot="append">
              <el-link
                type="primary"
                style="margin-right: 10px"
                @click="storeVisible = true"
              >
                编辑
              </el-link>
              <el-link
                type="primary"
                @click="clearStore"
              >
                重置
              </el-link>
            </div>
          </el-input>
        </template>
        <template v-slot:name="{ value }">
          <el-input
            v-model="value.keyword"
            class="name-mobile-input"
            placeholder="请输入内容"
          >
            <el-select
              slot="prepend"
              v-model="keywordType"
              style="width: 120px"
              placeholder="请选择"
              size="small"
            >
              <el-option
                v-for="(item, index) in keyWordMap"
                :key="index"
                :label="item"
                :value="index"
              />
            </el-select>
          </el-input>
        </template>
      </SpFinder>
    </el-tabs>
    <!-- 编辑门店 -->
    <SpStoreSelect
      v-model="storeVisible"
      :select-data="selectStoreData"
      @chooseStore="chooseStore"
    />
  </div>
</template>

<script>
import initFinderConfig from './comps/reportFinder'
import dayjs from 'dayjs'
export default {
  data () {
    const lastMonth = new Date().setMonth(new Date().getMonth() - 1)
    const config = initFinderConfig(this)
    const keyWordMap = {
      'employee_number': '员工工号',
      'salesperson_name': '员工姓名'
    }
    return {
      pickerOptions: {
        disabledDate (date) {
          return date.getTime() > lastMonth
        }
      },
      finderConfig: config, // finder配置
      selectStoreData: [], //门店选择结果
      storeVisible: false, //
      storeNum: null,
      keyWordMap,
      keywordType: 'employee_number',
      keyword: '',
      params: {
        month: dayjs(lastMonth).format('YYYY-MM')
      },
      activeName: '0'
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    beforeSearch (params) {
      params[this.keywordType] = params.keyword
      params['store_ids'] =
        (this.selectStoreData.length && this.selectStoreData.map((d) => d.store_id) + '') || null
      params['month'] = this.params.month || null
      console.log('beforeSearch:', params)
      return params
    },
    // 搜索重置
    onFinderReset () {
      this.selectStoreData = []
      this.keywordType = 'employee_number'
      this.storeNum = null
      this.params = {}
      this.keyword = ''
    },
    //重置门店选择
    clearStore () {
      this.storeIds = []
      this.storeNum = ''
      this.params.store_bn = []
      this.selectStoreData = []
    },
    // 选择门店
    chooseStore (selectdata, storeids) {
      console.log(selectdata, 'selectdataselectdata')
      this.selectStoreData = selectdata
      this.storeIds = storeids
      let storeBns = []
      selectdata.forEach((v) => {
        storeBns = storeBns.concat(v.store_bn)
      })
      this.params.store_bn = storeBns
      this.storeNum = '已选择' + selectdata.length + '家门店'
      this.storeVisible = false
    },

    handleClick (tab) {
      this.activeName = tab.name
      this.$refs.finder.refresh()
    }
  }
}
</script>
